import {
  Button,
  Input,
  Select,
  SelectItem,
  Checkbox,
  useDisclosure,
  Switch,
} from "@nextui-org/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  DropdownItem,
} from "@nextui-org/react";

import React, { useEffect, useState } from "react";
import SettingsLayout from "../layouts/SettingsLayout";
import { inputStyle, inputWrapperStyle } from "../data/inputStyleData";
import { getCities, getStates } from "../store/slices/countrySlice";
import { addAuth, updateProfileImg } from "../store/slices/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { refreshIfNeeded } from "../store/actions/refreshIfNeeded";
import Resizer from "react-image-file-resizer";
import { useNavigate } from "react-router-dom";
import { useLayoutEffect } from "react";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import { removeAuth } from "../store/slices/authSlice";
import ContactCustomerModal from "./ContactCustomerModal";

const UserProfile = () => {
  const user_role = localStorage.getItem("role");
  const accessToken = localStorage.getItem("accessToken");
  const supplierId = localStorage.getItem("user_id");
  const { status, user } = useSelector((state) => state.auth);
  const { states, cities } = useSelector((state) => state.country);
  // const [state, setState] = useState();
  // const [city, setCity] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isChecked, setIsChecked] = useState(false);
  const [Industry, setIndustry] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);
  const [busy, setBusy] = useState(false);

  const authHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });
  // Ensure token is fresh, then return headers
  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    return authHeaders();
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const handleConfirmDelete = async () => {
    if (busy) return;
    setIsDeleteModalOpen(false); // close modal first (avoids setState after navigate)
    await blockUser(); // this already handles busy + navigate
  };

  const blockUser = async () => {
    setBusy(true);
    try {
      const headers = await ensureAuth();
      await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/users/blockandunblock?action=BLOCK`,
        {},
        headers
      );
      toast.success("✅ Your account is deleted successfully");
      localStorage.clear();
      dispatch(removeAuth());
      navigate("/login");
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "❌ Failed to delete user";
      toast.error(msg);
      if (error?.response?.status === 401) {
        localStorage.clear();
        dispatch(removeAuth());
        navigate("/login");
      }
    } finally {
      setBusy(false);
    }
  };
  const {
    isOpen: addAssignee,
    onOpen: sumAssignee,
    onClose: closeAssignee,
  } = useDisclosure();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { control, register, setValue, handleSubmit, reset, watch } = useForm({
    defaultValues: {
      country: "Australia",
    },
  });

  // useEffect(() => {
  //   if (!supplierId || !accessToken) return;

  //   const fetchMailAllowed = async () => {
  //     try {
  //       const resp = await axios.get(
  //         `${process.env.REACT_APP_SERVER_URL}/users/mailallowed/${supplierId}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${accessToken}`,
  //           },
  //         }
  //       );

  //       // resp.data looks like:
  //       // { message: "Check Supplier E-mail is Allowed",
  //       //   data: { isAllowed: true } }
  //       const allowed = resp.data?.data?.isAllowed ?? false;
  //       setIsAllowed(allowed);
  //     } catch (err) {
  //       console.error("Could not load mail-allowed flag", err);
  //     }
  //   };

  //   fetchMailAllowed();
  // }, [supplierId, accessToken]);

  useLayoutEffect(() => {
    if (accessToken && !user?.first_name) {
      (async () => {
        try {
          const headers = await ensureAuth();
          const { data } = await axios.get(
            `${process.env.REACT_APP_SERVER_URL}/users/me`,
            headers
          );
          dispatch(addAuth({ ...data.details }));
        } catch (err) {
          console.error("User load failed:", err);
        }
      })();
    }
  }, [accessToken, user?.first_name, dispatch]);

  useEffect(() => {
    if (user?.city) setValue("city", user.city);
  }, [user?.city, setValue]);

  useEffect(() => {
    if (!supplierId || !accessToken) return;

    (async () => {
      try {
        const headers = await ensureAuth();
        const resp = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/users/mailallowed/${supplierId}`,
          headers
        );
        const allowed = resp.data?.data?.isAllowed ?? false;
        setIsAllowed(allowed);
      } catch (err) {
        console.error(err);
      }
    })();
  }, [supplierId, accessToken]);

  useEffect(() => {
    if (user?.Industry) {
      setValue("Industry", user.Industry);
    }
  }, [user, setValue]);

  // useEffect(() => {
  //   const storedCity = localStorage.getItem("city") || user?.city || "";
  //   setValue("city", storedCity);
  // }, [setValue, user?.city]);

  useEffect(() => {
    if (user?.isAllowed !== undefined) {
      setIsAllowed(user.isAllowed);
    }
  }, [user]);

  // const handleToggle = async (newValue) => {
  //   try {
  //     const url = `${process.env.REACT_APP_SERVER_URL}/api/v1/users/onoff/${supplierId}?isAllowed=${newValue}`;

  //     await axios.put(
  //       url,
  //       // no JSON body, so pass null
  //       null,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //         // tell Axios “this is text, don’t try to JSON.parse”
  //         responseType: "text",
  //       }
  //     );

  //     setIsAllowed(newValue);
  //     toast.success(
  //       `Supplier ${newValue ? "enabled" : "disabled"} successfully`
  //     );
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Failed to update setting");
  //   }
  // };

  const handleToggle = async (newValue) => {
    try {
      // const url = `http://localhost:8081/api/v1/users/onoff/${supplierId}?isAllowed=${newValue}`;
      //http://localhost:8081/api/v1/users/onoff/64?isAllowed=true
      const url = `${process.env.REACT_APP_SERVER_URL}/users/onoff/${supplierId}?isAllowed=${newValue}`;

      const headers = await ensureAuth();
      await axios.put(url, null, headers);

      setIsAllowed(newValue);
      toast.success(
        `Supplier ${newValue ? "enabled" : "disabled"} successfully`
      );
    } catch (err) {
      console.error(err);
      toast.error("Failed to update setting");
    }
  };

  const updateUser = async () => {
    const headers = await ensureAuth(); // refresh + latest token
    const res = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/users/me`,
      headers
    );
    dispatch(
      addAuth({
        ...res.data.details,
      })
    );
  };

  const handleCancelDel = () => {
    setIsDeleteModalOpen(false);
  };
  const handleUpload = async (e) => {
    const files = Array.from(e.target.files || []);

    // ➊ Max-5 safeguard
    if (files.length + images.length > 5) {
      toast.error("Sirf 5 images tak upload kar sakte hain");
      return;
    }
    // ➋ Loop over files
    files.forEach((file) => {
      Resizer.imageFileResizer(
        file,
        300,
        300,
        "JPEG",
        100,
        0,
        (uri) => {
          // local preview
          setImages((prev) => [...prev, URL.createObjectURL(file)]);

          // backend dispatch (agar ek-ek karke bhejna hai)
          dispatch(updateProfileImg(uri));
        },
        "file",
        200,
        200
      );
    });
  };
  const [isRegistered, setIsRegistered] = useState(false);

  const [images, setImages] = useState([]);
  const handleStripe = async () => {
    try {
      const headers = await ensureAuth();
      let res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/payment/registerSupplierStripe`,
        {},
        {
          ...headers,
          headers: { ...headers.headers, "Content-Type": "application/json" },
        }
      );
      if (res.data.url) {
        window.open(res.data.url, "_blank");
      }
    } catch (error) {
      if (error.response.data.error === "You are already existed") {
        setIsRegistered(true);
        toast.info("Already connected to Stripe!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        if (error.response.data.error === "You are already existed") {
          setIsRegistered(true);
        }
      }
      console.error("ERRRROOOORRRRR", error.response.statusr);
    }
  };

  const addModel = () => {
    sumAssignee();
  };

  const onSubmit = async (data) => {
    try {
      const headers = await ensureAuth();
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/users/update`,
        {
          ...data,
          suburb: data.suburb,
          state: data.state,
        },
        {
          ...headers,
          headers: { ...headers.headers, "Content-Type": "application/json" },
        }
      );
      if (response?.data?.details?.user) {
        updateUser();
        setValue("Industry", response?.data?.details?.user?.Industry);
        // toast.success("Profile Updated successfully ⭐");
      }
      toast.success("Profile Updated successfully ⭐");
    } catch (error) {
      let err = error.response?.data?.message;
      toast.error(err);
    }
  };

  useEffect(() => {
    if (user?.Industry) {
      setValue("Industry", user.Industry);
    }
  }, [user, setValue]);
  const handleCancel = () => {
    navigate("/requests");
  };

  // const handleStateChange = async (e) => {
  //   const data = {
  //     state: e?.currentKey,
  //   };
  //   setState(e?.currentKey);
  //   dispatch(getCities(data));
  // };

  // useEffect(() => {
  //   dispatch(getStates());
  //   if (user?.state) {
  //     dispatch(getCities({ state: user?.state }));
  //     setState(user?.state);
  //   }
  // }, [dispatch, user?.state]);
  useEffect(() => {
    dispatch(getStates());
    if (user?.state) {
      dispatch(getCities({ state: user?.state }));
    }
  }, [dispatch, user?.state]);

  // useEffect(() => {}, [states, cities, state, city]);

  useEffect(() => {
    if (user) {
      if (user_role === "CUSTOMER") {
        reset({
          first_name: user.first_name,
          last_name: user.last_name,
          phone: user.phone,
          address_line_1: user.address_line_1,
          address_line_2: String(user.address_line_2 ?? ""),
          suburb: user.suburb,
          postcode: user.postcode,
          business_name: user.business_name,
          capricorn_number: String(user.capricorn_number ?? ""),
          Industry: user.Industry,
          state: user.state || "",
          city: user.city || "",
        });
      } else {
        reset({
          first_name: user.first_name,
          last_name: user.last_name,
          phone: user.phone,
          address_line_1: user.address_line_1,
          address_line_2: user.address_line_2,
          suburb: user.suburb,
          postcode: user.postcode,
          company_name: user.company_name,
          capricorn_number: user.capricorn_number,
          state: user.state || "",
          city: user.city || "",
        });
      }
      // setCity(user?.suburb);
    }
  }, [user, user?.profile_id, user_role, reset]);

  return (
    <div className="px-2 sm:px-8 md:px-14">
      <div className="py-4 flex flex-col md:flex-row gap-4 md:gap-0 md:justify-between md:items-center">
        <div className="py-3 flex flex-col sm:flex-row items-center gap-4">
          {user?.profile_id ? (
            <img
              src={user.profile_id}
              alt="profile-pic"
              height="120px"
              width="120px"
              className="rounded-full"
            />
          ) : (
            <div className="w-28 h-28 bg-gray-200 border-1 border-gray-500 rounded-full"></div>
          )}
          <div className="text-center sm:text-left">
            <p className="text-base font-semibold">
              <span>{user?.email}</span>
            </p>

            <p className="text-xs">{user?.role}</p>

            {user_role === "SUPPLIER" && (
              <>
                <p className="text-base font-semibold">Block Email</p>
                <Switch
                  // checked={isAllowed}
                  isSelected={isAllowed}
                  onChange={(e) => handleToggle(e.target.checked)}
                  size="sm"
                  aria-label="Allow Email"
                />
              </>
            )}
            {/* <p>Allow Email </p>
            <Switch
              // checked={isAllowed}
              isSelected={isAllowed}
              onChange={(e) => handleToggle(e.target.checked)}
              size="sm"
              aria-label="Allow Email"
            /> */}

            {/* {console.log("USerROLE",user.role)} */}

            {user?.blocked === true && (
              <Button className="bg-red-400 text-white font-semibold px-7 mt-3 mobile-only:w-full">
                Blocked
              </Button>
            )}
          </div>
        </div>
        <div>
          <Input
            type="file"
            // multiple
            label="Edit your profile image"
            className="mb-2"
            classNames={{
              input: [...inputStyle, "user-profile"],
              inputWrapper: inputWrapperStyle,
            }}
            accept="image/*"
            labelPlacement={"outside"}
            placeholder="Choose images"
            // description={"( Max 5 images )"}
            onChange={(e) => handleUpload(e)}
          />
          {user_role === "SUPPLIER" && (
            <Button
              variant="bordered"
              className="px-3 py-1 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={isRegistered ? () => navigate("/quotes") : handleStripe}
            >
              {isRegistered ? "Already Connected to Stripe" : "Connect Stripe"}
            </Button>
          )}
        </div>
      </div>
      <div className="text-xl font-semibold border-b-1 border-gray-300 pb-2 mb-6">
        Edit Your Profile{" "}
      </div>

      <form className="md:px-10 space-y-12" onSubmit={handleSubmit(onSubmit)}>
        <SettingsLayout heading="Personal Info">
          <div className="grid sm:grid-cols-2 gap-6">
            <Controller
              control={control}
              name="first_name"
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Input
                  {...field} // value, onChange, onBlur
                  label="FIRST NAME"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder=" "
                  classNames={{ input: ["capitalize"] }}
                />
              )}
            />
            <Controller
              control={control}
              name="last_name"
              rules={{
                // 3️⃣ validation rules
                required: "This field is required",
              }}
              render={({ field, fieldState }) => (
                <Input
                  {...field}
                  type="text"
                  label="LAST NAME"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder=" "
                  classNames={{ input: ["capitalize"] }}
                  errorMessage={fieldState.error?.message}
                />
              )}
            />
            <Controller
              control={control}
              name="phone"
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Input
                  {...field}
                  type="number"
                  label="PHONE NUMBER"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder=" "
                  onWheel={(e) => e.target.blur()}
                />
              )}
            />
            {user_role === "ADMIN" ? (
              <Input
                type="password"
                label="PASSWORD"
                labelPlacement="outside"
                variant="bordered"
                placeholder=" "
                {...register("password", {
                  required: "This field is required",
                })}
              />
            ) : (
              <div className="flex justify-end">
                <Button
                  onClick={() => addModel()}
                  className="bg-white text-blue-500 border border-lightBlue mt-6 font-semibold mb-5 w-1/2 px-7 mobile-only:w-full md:px-16"
                >
                  Contract Info
                </Button>
              </div>
            )}
          </div>
        </SettingsLayout>

        <SettingsLayout heading="Business Info">
          {user_role === "SUPPLIER" ? (
            <div className="grid sm:grid-cols-2 gap-6">
              <Input
                isReadOnly
                type="text"
                label="COMPANY NAME"
                labelPlacement="outside"
                classNames={{
                  input: ["capitalize", "cursor-not-allowed"],
                }}
                variant="bordered"
                placeholder=" "
                value={user?.company_name}
              />
              <Input
                isReadOnly
                type="number"
                label="ABN NUMBER"
                labelPlacement="outside"
                value={user?.abn_number}
                classNames={{
                  input: ["capitalize", "cursor-not-allowed"],
                }}
                variant="bordered"
                placeholder="0"
              />
              <Input
                isReadOnly
                type="text"
                label="SUPPLIER TYPE"
                labelPlacement="outside"
                value={user?.supplierType?.name}
                classNames={{
                  input: ["capitalize", "cursor-not-allowed"],
                }}
                variant="bordered"
                placeholder=" "
              />

              <Input
                isReadOnly
                type="text"
                label="COMMISSION RATE"
                labelPlacement="outside"
                value={user?.CommissionRate?.rate || 0}
                classNames={{
                  input: ["capitalize", "cursor-not-allowed"],
                }}
                variant="bordered"
                placeholder=" "
              />
              <Controller
                control={control}
                name="capricorn_number"
                render={({ field, fieldState }) => (
                  <Input
                    {...field}
                    type="text" // ✅ text, not number
                    label="CAPRICORN NUMBER"
                    labelPlacement="outside"
                    variant="bordered"
                    placeholder="Capricorn Number"
                    onWheel={(e) => e.currentTarget.blur()}
                    errorMessage={fieldState.error?.message}
                  />
                )}
              />

              <Select
                {...register("Industry")}
                variant="bordered"
                label="Industry"
                labelPlacement="outside"
                placeholder=" "
                selectedKeys={[watch("Industry")]}
              >
                <SelectItem key="Collision Repairer" value="Collision Repairer">
                  Collision Repairer
                </SelectItem>
                <SelectItem key="Dismantler" value="Dismantler">
                  Dismantler
                </SelectItem>
                <SelectItem key="Mechanic" value="Mechanic">
                  Mechanic
                </SelectItem>
                <SelectItem key="Private" value="Private">
                  Private
                </SelectItem>
                <SelectItem key="Reseller" value="Reseller">
                  Reseller
                </SelectItem>
              </Select>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 gap-6">
              <Input
                type="text"
                label="BUSSINESS NAME"
                labelPlacement="outside"
                classNames={{
                  input: ["capitalize"],
                }}
                variant="bordered"
                placeholder=" "
                value={user?.business_name}
                {...register("business_name", {
                  required: false,
                })}
              />

              <Controller
                control={control}
                name="capricorn_number"
                render={({ field, fieldState }) => (
                  <Input
                    {...field}
                    type="text"
                    label="CAPRICORN NUMBER"
                    labelPlacement="outside"
                    variant="bordered"
                    placeholder="Capricorn Number"
                    onWheel={(e) => e.currentTarget.blur()}
                    errorMessage={fieldState.error?.message}
                  />
                )}
              />
            </div>
          )}
        </SettingsLayout>

        <SettingsLayout heading="Address Info">
          <div className="grid sm:grid-cols-2 gap-6">
            <Controller
              control={control}
              name="address_line_1"
              defaultValue={user?.address_line_1 || ""}
              rules={{ required: false }}
              render={({ field, fieldState }) => (
                <Input
                  {...field}
                  type="text"
                  label="ADDRESS LINE 1"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder=" "
                  classNames={{ input: ["capitalize"] }}
                  errorMessage={fieldState.error?.message}
                />
              )}
            />

            <Controller
              control={control}
              name="address_line_2"
              defaultValue={user?.address_line_2 || ""}
              render={({ field }) => (
                <Input
                  {...field}
                  type="text"
                  label="ADDRESS LINE 2"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder=" "
                  classNames={{ input: ["capitalize"] }}
                />
              )}
            />

            <Input
              {...register("country")}
              type="text"
              variant="bordered"
              label="COUNTRY"
              labelPlacement="outside"
              placeholder=" "
              isReadOnly
              className="pointer-events-none"
            />
            <Controller
              control={control}
              name="state"
              render={({ field }) => (
                <Select
                  selectedKeys={field.value ? [field.value] : []}
                  onSelectionChange={(keys) => {
                    const val = Array.from(keys).join("");
                    field.onChange(val); // RHF update
                    if (val) dispatch(getCities({ state: val })); // cities reload
                  }}
                  variant="bordered"
                  label="State"
                  labelPlacement="outside"
                  placeholder=" "
                >
                  {states?.length ? (
                    states.map((item) => (
                      <SelectItem key={item.name}>{item.name}</SelectItem>
                    ))
                  ) : (
                    <SelectItem key="loading">Fetching the data...</SelectItem>
                  )}
                </Select>
              )}
            />

            <Controller
              control={control}
              name="city"
              render={({ field, fieldState }) => (
                <Input
                  {...field}
                  type="text"
                  label="CITY"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder=" "
                  classNames={{ input: ["capitalize"] }}
                  errorMessage={fieldState.error?.message}
                />
              )}
            />
            <Controller
              control={control}
              name="postcode"
              defaultValue={user?.postcode || ""}
              rules={{
                pattern: {
                  value: /^\d{4}$/,
                  message: "4 digit ka valid post code dālīye",
                },
              }}
              render={({ field, fieldState }) => (
                <Input
                  {...field}
                  type="text"
                  label="POST CODE"
                  labelPlacement="outside"
                  variant="bordered"
                  placeholder=" "
                  inputMode="numeric"
                  classNames={{ input: ["capitalize"] }}
                  errorMessage={fieldState.error?.message}
                />
              )}
            />
          </div>
        </SettingsLayout>

        <SettingsLayout divider={false}>
          <div className="">
            <Button
              className="bg-lightBlue text-white font-semibold mb-5 px-7 mobile-only:w-full"
              type="submit"
            >
              Save Changes
            </Button>
            <Button
              className="bg-purpleBtn text-white font-semibold px-7 sm:ml-7 mobile-only:w-full"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            {/* Delete button */}
            {(user?.role === "SUPPLIER" || user?.role === "CUSTOMER") && (
              <Button
               
                   className="bg-danger text-white font-semibold px-7 sm:ml-7 mobile-only:w-full"
                onClick={() => setIsDeleteModalOpen(true)}
                isDisabled={busy}
              >
               Account Delete
              </Button>
            )}
          </div>
        </SettingsLayout>
      </form>

      <ContactCustomerModal
        isOpen={addAssignee}
        onClose={closeAssignee}
        user_role="SUPPLIER"
      />
      {/* Delete Confirmation Modal */}
      <Modal closeButton blur isOpen={isDeleteModalOpen} onClose={handleCancel}>
        <ModalContent>
          <ModalHeader className="text-danger font-bold">
            Confirm Deletion
          </ModalHeader>
          <ModalBody>
            <p>⚠️ Are you sure you want to delete this account?</p>
            <p>This action cannot be undone.</p>
          </ModalBody>
          <ModalFooter>
            {/* Cancel Button */}
            <Button variant="light" onPress={handleCancelDel} isDisabled={busy}>
              Cancel
            </Button>

            {/* Delete Button */}
            <Button
              color="danger"
              onPress={handleConfirmDelete}
              isDisabled={busy}
              isLoading={busy}
            >
              Yes, Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default UserProfile;
